import { TarefaLogFiltrosCriteria, TarefaLogFiltrosOptions } from "@workflow/types";
import { TarefaLogDTO } from "@/types/tarefa-log.type";
import { PageResponse } from "@/types/http.type";
import { buildQueryParams } from "@/utils/build-query-params";
import { httpClient } from "./httpClient";

/**
 * Auditoria admin de tarefas: histórico de eventos de negócio de todas as
 * tarefas do sistema. Espelha o `ArquivoAuditoriaService`.
 */
class TarefaAuditoriaService {
  private readonly basePath = "api/v1/admin/tarefas";

  public async listLogsPaginado(
    filter?: TarefaLogFiltrosCriteria,
  ): Promise<PageResponse<TarefaLogDTO>> {
    let url = `${this.basePath}/logs/listagem`;
    if (filter) {
      const query = buildQueryParams(filter);
      if (query) url += "?" + query;
    }
    return httpClient.get<PageResponse<TarefaLogDTO>>(url);
  }

  public async getLogFiltros(): Promise<TarefaLogFiltrosOptions> {
    return httpClient.get<TarefaLogFiltrosOptions>(`${this.basePath}/logs/filtros`);
  }
}

export const tarefaAuditoriaService = new TarefaAuditoriaService();
